import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormModel} from './form.model';

@Component({
    selector: 'app-component-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

    @Output('formData') formData = new EventEmitter<any>();
    @Input('requestData') requestData: boolean;

    public myFormGroup: FormGroup;
    public inviteList = [];
    public activeData;
    @Input('data') public data: FormModel[] = [];
    private subs = [];
    private observers = [];

    constructor(private cdRef: ChangeDetectorRef) {
    }

    private get validateData(): boolean {
        let valid = true;
        if (this.myFormGroup) {
            for (const key in this.myFormGroup.controls) {
                if (!this.myFormGroup.controls[key].valid) {
                    valid = false;
                }
            }
        }
        if (!valid) {
            return valid;
        }
        if (this.inviteList && this.inviteList.length) {
            for (const item of this.inviteList) {
                if (!item.email ||
                    !item.completed ||
                    !item.formGroup.value.observ) {
                    valid = false;
                }
            }
        }
        return valid;
    }

    private get serializeInvites(): any {
        const data = [];
        for (const item of this.inviteList) {
            const object: any = {};
            object.email = item.email;
            object.observ = item.formGroup.controls.observ.value;
            object.position = item.formGroup.controls.position.value;
            if (!object.position) {
                delete object.position;
            }
            data.push({email: item.email, ...object});
        }
        return data;
    }

    ngOnInit(): void {
        const group = {};
        if (this.data.length > 0) {
            this.data.forEach(data => {
                if (data.type === 'file') {
                    group['fileSource'] = new FormControl();
                }
                group[data.formControlName] = new FormControl(data.formState ? data.formState : '',
                    data.required ? Validators.required : null);
                if (data.observe) {
                    this.observers.push(data.observe.split(':'));
                    data.observeVal = false;
                }
            });
            this.myFormGroup = new FormGroup(group);
            this.sendData();
        }
        if (this.myFormGroup) {
            this.subs.push(this.myFormGroup.valueChanges.subscribe(() => {
                this.sendData();
            }));
        }
    }

    selectedValue(form, val): void {
        this.myFormGroup.controls[form].setValue(val);
    }

    selectedValueByInvited(item, control, val): void {
        item.formGroup.controls[control].setValue(val);
    }

    onFileChange(formName, file): void {
        this.selectedValue(formName, file.name);
        this.myFormGroup.patchValue({
            fileSource: file,
        });
    }

    sendData(): void {
        if (this.myFormGroup && this.myFormGroup.value) {
            const data = this.myFormGroup.value;
            if (this.inviteList && this.inviteList.length) {
                data.invites = this.serializeInvites;
            }
            data.valid = this.validateData;
            this.activeData = data;
            this.formData.emit(data);
            for (const item of this.observers) {
                const childIndex = this.data.findIndex(x => x.formControlName === item[1]);
                this.data[childIndex].observeVal = data[item[0]];
                this.cdRef.detectChanges();
            }
        }
    }

    usersHandler(object): void {
        this.inviteList = object.data.invites || [];
        if (object.data.users) {
            // let joinedData = [...object.data.users, object.data.invites.map(x => x.email)].join(',');
            let joinedData = [];
            if (object.data.users) {
                joinedData = [...object.data.users];
            }
            if (object.data.invites) {
                joinedData = [...joinedData, ...object.data.invites.map(x => x.email)];
            }
            this.selectedValue(object.name, joinedData.join(','));
        }
    }

    /*inviteListAction(e) {
    	if (e.action === 'add') {
    		e.data.opened = false;
    		e.data.completed = false;
    		e.data.formGroup = new FormGroup({
			    observ: new FormControl('', Validators.required),
			    position: new FormControl('')
		    });
		    this.inviteList.push(e.data);
		    this.subs.push(
		    	e.data.formGroup.valueChanges.subscribe(data => {
		    		this.sendData();
			    })
		    )
	    }
	    if (e.action === 'remove') {
		    this.inviteList.forEach(((value, index) => {
		    	if (value.email === e.data.email) {
				    this.inviteList.splice(index, 1);
				    this.sendData();
			    }
		    }));
	    }
    }*/
}

